<template>
  <div class="system_name" style="cursor: pointer;">
    {{title}} {{ $t("original.foottitle")}}
  </div>
</template>


<script>

  export default {
    data() {
      return {
        title: sessionStorage.getItem('companyNM'),
      }
    },
    created() {

    },
    watch: {
      //监听
    },
    methods: {

    },
    mounted(){

    }
  }


</script>










<style scoped>
.system_name {
  height: 40px;
  background-color: rgba(255, 255, 255, 1);
  line-height: 40px;
  text-align: center;
  position: relative;
  z-index: 999;
  font-size: 12px;
  color: gray;
}
</style>
